<template>
    <section class="user-account grey lighten-3 ">
       <v-container
       class="d-flex justify-center "
       >
         <v-card
         class="user-card"
         >
          <v-card-title class="text-center user-image-profile" >
           <v-avatar color="black" left size="100" style="cursor:pointer">
           <v-img  :src="imgSrc" alt="user profile image" 
          max-width="108"
          height="108"
          :contain="true"
          >
          <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="white"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            </v-avatar>
           <v-btn class="edit-image" color="primary" x-small fab absolute ><v-icon small>fa fa-edit</v-icon></v-btn>
          </v-card-title>
           <v-tabs grow  class="mt-14" v-model="tab" background-color="whith">
            <v-tab >{{$t("userAccount.profile.generalInfo")}}</v-tab>
            <v-tab>{{$t("userAccount.paymentMethods.paymentMeth")}}</v-tab>
           </v-tabs>
           <v-tabs-items v-model="tab">
           <v-tab-item><AppUserProfile /></v-tab-item>
           <v-tab-item><AppUserPymentMethods /></v-tab-item>
           </v-tabs-items>
         </v-card>
       </v-container>
       <AppFooter />
    </section>
</template>

<script>
import AppUserProfile from '@/components/userAccount/Profile.vue';
import AppUserPymentMethods from '@/components/userAccount/PaymentMethods.vue';
import AppFooter from '@/components/footer/Footer';
import {userAvatar} from '@/mixins/index'

export default {
    name:'userAccount',
    data() {
        return {
            tab:''
        }
    },
    mixins:[userAvatar],
    components:{
        AppUserProfile,
        AppUserPymentMethods,
        AppFooter
    },
    created(){
      this.getuserAvatar(this.$store.state.User.avatar,this.$store.state.User.proveId)
    }
}
</script>

<style lang="scss" scoped>
    .user-account{
        width: 100%;
       
        .user-card{
            width: 70%;
            min-height: 74vh;
            margin-top:40px ;
            .user-image-profile{
                position: absolute;
                top: -60px;
                left: 50%;
                transform: translateX(-50%);
                .edit-image{
                    right: 0;
                    bottom: 20px;
                }
            }
        }
    }
    @media (max-width:600.95px){
        .user-card{
            width: 100% !important;
        }
    }
    @media (min-width: 601px) and (max-width:960px){
        .user-card{
            width: 80% !important;
        }
    }
</style>
